export const MembershipTypeFormName = 'membership-type-form';

export enum MembershipTypeFormFields {
  MembershipType = 'membershipType',
}
